import { render, staticRenderFns } from "./UnboundView.vue?vue&type=template&id=e2985b86&"
import script from "./UnboundView.vue?vue&type=script&lang=js&"
export * from "./UnboundView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports